import React, { Fragment } from 'react';
import { updateBookingCart } from 'Components/widgets/cart/cart.actions';
import { Capsule } from 'Components/frameworks/capsule/Capsule';
import type { IconName } from 'Components/frameworks/icon/Icon';
import { Icon } from 'Components/frameworks/icon/Icon';
import { CartServiceItem } from './CartServiceItem';
import { DashLine } from './DashLine';
type Props = {
  bookingId: string;
  iconLabel: string;
  iconName: IconName;
  serviceName: ServiceType;
  services: Array<CartChildcare>;
  stayIndex: number;
  updateCart: typeof updateBookingCart;
  stayAvailableServices: ReadonlyArray<UpsellChildcare>;
  isCartLocked?: boolean;
};
export const CartServices = ({
  bookingId,
  iconLabel,
  iconName,
  serviceName,
  services,
  stayIndex,
  updateCart,
  stayAvailableServices,
  isCartLocked = false,
}: Props) => {
  return (
    <Capsule className="mt-20" contentClassName="flex gap-10 items-start p-10">
      <Icon className="text-sienna" name={iconName} width="2rem" />
      <div className="flex-1">
        {services.map((item, i) => {
          const serviceProductInfo = stayAvailableServices.find(
            ({ productInfo }) => productInfo.id === item.productId,
          )?.productInfo;
          return (
            <Fragment key={item.id}>
              <p className="text-12 font-bold text-sienna">{iconLabel}</p>
              <CartServiceItem
                bookingId={bookingId}
                item={item}
                serviceName={serviceName}
                updateCart={updateCart}
                stayIndex={stayIndex}
                serviceProductInfo={serviceProductInfo}
                isCartLocked={isCartLocked}
              />
              {i < services.length - 1 && <DashLine />}
            </Fragment>
          );
        })}
      </div>
    </Capsule>
  );
};
